import { fetchWithAuth } from "./fetchWithAuth";

const API_BASE = process.env.REACT_APP_API_BASE;

const unauthorizedError = new Error("Неовластен пристап.");

const handleJsonResponse = async (response, fallbackMessage) => {
  if (!response) {
    throw unauthorizedError;
  }

  if (!response.ok) {
    const text = await response.text();
    const detail = text || fallbackMessage;
    throw new Error(detail);
  }

  return response.status === 204 ? null : response.json();
};

const buildSaveTheDateFormData = (payload = {}) => {
  const formData = new FormData();

  if (payload.title) {
    formData.append("title", payload.title);
  }
  if (payload.event_date) {
    formData.append("event_date", payload.event_date);
  }
  if (payload.location) {
    formData.append("location", payload.location);
  }
  if (payload.message) {
    formData.append("message", payload.message);
  }

  if (payload.is_public !== undefined) {
    formData.append("is_public", String(Boolean(payload.is_public)));
  }

  if (payload.cover_file) {
    formData.append("cover_file", payload.cover_file);
  }
  if (payload.footer_file) {
    formData.append("footer_file", payload.footer_file);
  }

  return formData;
};

export async function getUserSaveTheDates() {
  const response = await fetchWithAuth(`${API_BASE}/user/save-the-dates`, {
    method: "GET",
  });
  return handleJsonResponse(response, "Неуспешно вчитување на Save the Date.");
}

export async function createSaveTheDate(payload) {
  const response = await fetchWithAuth(`${API_BASE}/save-the-dates`, {
    method: "POST",
    body: buildSaveTheDateFormData(payload),
  });
  return handleJsonResponse(response, "Неуспешно креирање на Save the Date.");
}

export async function getUserSaveTheDate(saveTheDateId) {
  const response = await fetchWithAuth(
    `${API_BASE}/user/save-the-dates/${saveTheDateId}`,
    {
      method: "GET",
    }
  );
  return handleJsonResponse(response, "Save the Date не беше пронајден.");
}

export async function updateSaveTheDate(saveTheDateId, payload) {
  const response = await fetchWithAuth(
    `${API_BASE}/user/save-the-dates/${saveTheDateId}`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    }
  );
  return handleJsonResponse(response, "Неуспешно ажурирање на Save the Date.");
}

export async function deleteSaveTheDate(saveTheDateId) {
  const response = await fetchWithAuth(
    `${API_BASE}/user/save-the-dates/${saveTheDateId}`,
    {
      method: "DELETE",
    }
  );

  if (response && !response.ok) {
    const text = await response.text();
    throw new Error(text || "Неуспешно бришење на Save the Date.");
  }

  return true;
}

export async function uploadSaveTheDateCover(saveTheDateId, file) {
  if (!saveTheDateId || !file) {
    throw new Error("Недостасува Save the Date или датотека за насловна слика.");
  }

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetchWithAuth(
    `${API_BASE}/user/save-the-dates/${saveTheDateId}/cover`,
    {
      method: "POST",
      body: formData,
    }
  );
  return handleJsonResponse(
    response,
    "Неуспешно прикачување на насловната слика."
  );
}

export async function uploadSaveTheDateFooter(saveTheDateId, file) {
  if (!saveTheDateId || !file) {
    throw new Error("Недостасува Save the Date или датотека за долна слика.");
  }

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetchWithAuth(
    `${API_BASE}/user/save-the-dates/${saveTheDateId}/footer`,
    {
      method: "POST",
      body: formData,
    }
  );
  return handleJsonResponse(
    response,
    "Неуспешно прикачување на долната слика."
  );
}

export async function getSaveTheDateBySlug(slug) {
  const response = await fetch(`${API_BASE}/save-the-dates/${slug}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Save the Date не беше пронајден.");
  }

  return response.json();
}
